export default __webpack_public_path__ + "static/media/left_PC.4650d614.svg";